import { NOTIFICATION_CHANNEL_OPTIONS } from '@lms/shared'
import { SelectItem } from '@/components/ui/select'

/** 通知チャネルの選択肢（未提供のチャネルは「準備中」で無効表示） */
export function NotificationChannelSelectItems() {
  return (
    <>
      <SelectItem value="none">なし</SelectItem>
      {NOTIFICATION_CHANNEL_OPTIONS.map((o) => (
        <SelectItem key={o.value} value={o.value} disabled={!o.available}>
          {o.available ? o.label : `${o.label}（準備中）`}
        </SelectItem>
      ))}
    </>
  )
}
